var map = {
	"./avatar.png": "7dbe",
	"./card-active.png": "61e7",
	"./card.png": "7c2d",
	"./chevron-down.svg": "d123",
	"./image.png": "8c62",
	"./my-numbers-active.png": "e31d",
	"./my-numbers.png": "f6a9",
	"./my-transactions-active.png": "b96c",
	"./my-transactions.png": "0929",
	"./notification-active.png": "ea83",
	"./notification.png": "9da9",
	"./personal-active.png": "41d9",
	"./personal.png": "5718",
	"./recurring-active.png": "2da2",
	"./recurring.png": "d331",
	"./wallet-active.png": "b0c1",
	"./wallet.png": "7999"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba6f";